// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { DocumentsAbortUploadData, DocumentsAbortUploadErrors, DocumentsAbortUploadResponses, DocumentsClassifyDocumentData, DocumentsClassifyDocumentErrors, DocumentsClassifyDocumentResponses, DocumentsCompleteUploadData, DocumentsCompleteUploadErrors, DocumentsCompleteUploadResponses, DocumentsConfirmRevisionData, DocumentsConfirmRevisionErrors, DocumentsConfirmRevisionResponses, DocumentsCreateDocumentData, DocumentsCreateDocumentErrors, DocumentsCreateDocumentResponses, DocumentsCreateUploadData, DocumentsCreateUploadErrors, DocumentsCreateUploadResponses, DocumentsDeleteFileData, DocumentsDeleteFileErrors, DocumentsFilePresentationData, DocumentsFilePresentationErrors, DocumentsFilePresentationResponses, DocumentsGetDocumentData, DocumentsGetDocumentErrors, DocumentsGetDocumentResponses, DocumentsGetUploadData, DocumentsGetUploadErrors, DocumentsGetUploadResponses, DocumentsListDocumentsData, DocumentsListDocumentsErrors, DocumentsListDocumentsResponses, DocumentsRemoveFileFromDraftData, DocumentsRemoveFileFromDraftErrors, DocumentsRemoveFileFromDraftResponses, DocumentsReplaceFileBytesData, DocumentsReplaceFileBytesErrors, DocumentsResolvePresentationData, DocumentsResolvePresentationErrors, DocumentsResolvePresentationResponses, DocumentsSearchDocumentsData, DocumentsSearchDocumentsErrors, DocumentsSearchDocumentsResponses, DocumentsSetFileRoleData, DocumentsSetFileRoleErrors, DocumentsSetFileRoleResponses, DocumentsUploadPartUrlsData, DocumentsUploadPartUrlsErrors, DocumentsUploadPartUrlsResponses, EngineeringChangeCatalogueItemData, EngineeringChangeCatalogueItemErrors, EngineeringChangeCatalogueItemResponses, EngineeringConfirmAttributeData, EngineeringConfirmAttributeErrors, EngineeringConfirmAttributeResponses, EngineeringCreateCatalogueItemData, EngineeringCreateCatalogueItemErrors, EngineeringCreateCatalogueItemResponses, EngineeringCreatePartData, EngineeringCreatePartErrors, EngineeringCreatePartResponses, EngineeringCreateRevisionData, EngineeringCreateRevisionErrors, EngineeringCreateRevisionResponses, EngineeringDecideAttributeProposalData, EngineeringDecideAttributeProposalErrors, EngineeringDecideAttributeProposalResponses, EngineeringDecideSignalData, EngineeringDecideSignalErrors, EngineeringDecideSignalResponses, EngineeringEnsureRecipeData, EngineeringEnsureRecipeErrors, EngineeringEnsureRecipeResponses, EngineeringGetPartData, EngineeringGetPartErrors, EngineeringGetPartResponses, EngineeringGetRecipeData, EngineeringGetRecipeErrors, EngineeringGetRecipeResponses, EngineeringGetRecipeVersionData, EngineeringGetRecipeVersionErrors, EngineeringGetRecipeVersionResponses, EngineeringLinkEvidenceData, EngineeringLinkEvidenceErrors, EngineeringLinkEvidenceResponses, EngineeringListCatalogueData, EngineeringListCatalogueErrors, EngineeringListCatalogueResponses, EngineeringPartRevisionReferenceData, EngineeringPartRevisionReferenceErrors, EngineeringPartRevisionReferenceResponses, EngineeringRecordEquivalenceData, EngineeringRecordEquivalenceErrors, EngineeringRecordEquivalenceResponses, EngineeringRecordSignalData, EngineeringRecordSignalErrors, EngineeringRecordSignalResponses, EngineeringReplacePartData, EngineeringReplacePartErrors, EngineeringReplacePartResponses, EngineeringSaveRecipeVersionData, EngineeringSaveRecipeVersionErrors, EngineeringSaveRecipeVersionResponses, EngineeringSearchPartsData, EngineeringSearchPartsErrors, EngineeringSearchPartsResponses, EngineeringTechnicalBasisData, EngineeringTechnicalBasisErrors, EngineeringTechnicalBasisResponses, EngineeringUnlinkEvidenceData, EngineeringUnlinkEvidenceErrors, EngineeringUnlinkEvidenceResponses, EngineeringUpdatePartData, EngineeringUpdatePartErrors, EngineeringUpdatePartResponses, EngineeringUpdateRevisionData, EngineeringUpdateRevisionErrors, EngineeringUpdateRevisionResponses, HealthLiveData, HealthLiveResponses, HealthReadyData, HealthReadyResponses, PlatformActivatePoliciesData, PlatformActivatePoliciesErrors, PlatformActivatePoliciesResponses, PlatformChangeCapabilityMappingData, PlatformChangeCapabilityMappingErrors, PlatformChangeCapabilityMappingResponses, PlatformChangeInvitationRoleData, PlatformChangeInvitationRoleErrors, PlatformChangeInvitationRoleResponses, PlatformChangeRoleData, PlatformChangeRoleErrors, PlatformChangeRoleResponses, PlatformDeactivateData, PlatformDeactivateErrors, PlatformDeactivateResponses, PlatformGetCapabilityMappingData, PlatformGetCapabilityMappingErrors, PlatformGetCapabilityMappingResponses, PlatformGetMeData, PlatformGetMeErrors, PlatformGetMeResponses, PlatformGetPoliciesData, PlatformGetPoliciesErrors, PlatformGetPoliciesResponses, PlatformGetPolicyVersionData, PlatformGetPolicyVersionErrors, PlatformGetPolicyVersionResponses, PlatformInviteData, PlatformInviteErrors, PlatformInviteResponses, PlatformListAuditData, PlatformListAuditErrors, PlatformListAuditResponses, PlatformListInvitationsData, PlatformListInvitationsErrors, PlatformListInvitationsResponses, PlatformListMembersData, PlatformListMembersErrors, PlatformListMembersResponses, PlatformListOrganizationsData, PlatformListOrganizationsResponses, PlatformListPolicyVersionsData, PlatformListPolicyVersionsErrors, PlatformListPolicyVersionsResponses, PlatformPatchMeData, PlatformPatchMeErrors, PlatformPatchMeResponses, PlatformReactivateData, PlatformReactivateErrors, PlatformReactivateResponses, PlatformRenewData, PlatformRenewErrors, PlatformRenewResponses, PlatformRevokeData, PlatformRevokeErrors, PlatformRevokeResponses, PlatformSavePolicyDraftData, PlatformSavePolicyDraftErrors, PlatformSavePolicyDraftResponses, SalesActivatePriceBookVersionData, SalesActivatePriceBookVersionErrors, SalesActivatePriceBookVersionResponses, SalesAddContactData, SalesAddContactErrors, SalesAddContactResponses, SalesCreateCustomerData, SalesCreateCustomerErrors, SalesCreateCustomerResponses, SalesCreatePriceBookData, SalesCreatePriceBookErrors, SalesCreatePriceBookResponses, SalesCreatePriceBookVersionData, SalesCreatePriceBookVersionErrors, SalesCreatePriceBookVersionResponses, SalesCreateQuoteData, SalesCreateQuoteErrors, SalesCreateQuoteResponses, SalesCreateRequestData, SalesCreateRequestErrors, SalesCreateRequestResponses, SalesGetCalculationData, SalesGetCalculationErrors, SalesGetCalculationResponses, SalesGetCustomerData, SalesGetCustomerErrors, SalesGetCustomerResponses, SalesGetPriceBookData, SalesGetPriceBookErrors, SalesGetPriceBookResponses, SalesGetPriceBookVersionData, SalesGetPriceBookVersionErrors, SalesGetPriceBookVersionResponses, SalesGetQuoteData, SalesGetQuoteErrors, SalesGetQuoteResponses, SalesGetQuoteVersionData, SalesGetQuoteVersionErrors, SalesGetQuoteVersionResponses, SalesGetRequestData, SalesGetRequestErrors, SalesGetRequestResponses, SalesInternalSummaryData, SalesInternalSummaryErrors, SalesInternalSummaryResponses, SalesListCalculationsData, SalesListCalculationsErrors, SalesListCalculationsResponses, SalesListPriceBooksData, SalesListPriceBooksErrors, SalesListPriceBooksResponses, SalesListSupplierEvidenceData, SalesListSupplierEvidenceErrors, SalesListSupplierEvidenceResponses, SalesPreviewCalculationData, SalesPreviewCalculationErrors, SalesPreviewCalculationResponses, SalesRecordSupplierEvidenceData, SalesRecordSupplierEvidenceErrors, SalesRecordSupplierEvidenceResponses, SalesSaveCalculationData, SalesSaveCalculationErrors, SalesSaveCalculationResponses, SalesSaveQuoteVersionData, SalesSaveQuoteVersionErrors, SalesSaveQuoteVersionResponses, SalesSearchCustomersData, SalesSearchCustomersErrors, SalesSearchCustomersResponses, SalesSearchQuotesData, SalesSearchQuotesErrors, SalesSearchQuotesResponses, SalesSearchRequestsData, SalesSearchRequestsErrors, SalesSearchRequestsResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * List Documents
 */
export const documentsListDocuments = <ThrowOnError extends boolean = false>(options?: Options<DocumentsListDocumentsData, ThrowOnError>): RequestResult<DocumentsListDocumentsResponses, DocumentsListDocumentsErrors, ThrowOnError> => (options?.client ?? client).get<DocumentsListDocumentsResponses, DocumentsListDocumentsErrors, ThrowOnError>({ url: '/api/documents/documents', ...options });

/**
 * Create Document
 */
export const documentsCreateDocument = <ThrowOnError extends boolean = false>(options: Options<DocumentsCreateDocumentData, ThrowOnError>): RequestResult<DocumentsCreateDocumentResponses, DocumentsCreateDocumentErrors, ThrowOnError> => (options.client ?? client).post<DocumentsCreateDocumentResponses, DocumentsCreateDocumentErrors, ThrowOnError>({
    url: '/api/documents/documents',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Document
 */
export const documentsGetDocument = <ThrowOnError extends boolean = false>(options: Options<DocumentsGetDocumentData, ThrowOnError>): RequestResult<DocumentsGetDocumentResponses, DocumentsGetDocumentErrors, ThrowOnError> => (options.client ?? client).get<DocumentsGetDocumentResponses, DocumentsGetDocumentErrors, ThrowOnError>({ url: '/api/documents/documents/{document_id}', ...options });

/**
 * Classify Document
 */
export const documentsClassifyDocument = <ThrowOnError extends boolean = false>(options: Options<DocumentsClassifyDocumentData, ThrowOnError>): RequestResult<DocumentsClassifyDocumentResponses, DocumentsClassifyDocumentErrors, ThrowOnError> => (options.client ?? client).patch<DocumentsClassifyDocumentResponses, DocumentsClassifyDocumentErrors, ThrowOnError>({
    url: '/api/documents/documents/{document_id}/classification',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirm Revision
 */
export const documentsConfirmRevision = <ThrowOnError extends boolean = false>(options: Options<DocumentsConfirmRevisionData, ThrowOnError>): RequestResult<DocumentsConfirmRevisionResponses, DocumentsConfirmRevisionErrors, ThrowOnError> => (options.client ?? client).post<DocumentsConfirmRevisionResponses, DocumentsConfirmRevisionErrors, ThrowOnError>({
    url: '/api/documents/documents/{document_id}/revisions/{revision_id}/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove File From Draft
 *
 * Remove a file from a DRAFT revision (the immutable file stays resolvable).
 */
export const documentsRemoveFileFromDraft = <ThrowOnError extends boolean = false>(options: Options<DocumentsRemoveFileFromDraftData, ThrowOnError>): RequestResult<DocumentsRemoveFileFromDraftResponses, DocumentsRemoveFileFromDraftErrors, ThrowOnError> => (options.client ?? client).delete<DocumentsRemoveFileFromDraftResponses, DocumentsRemoveFileFromDraftErrors, ThrowOnError>({ url: '/api/documents/documents/{document_id}/revisions/{revision_id}/files/{file_id}', ...options });

/**
 * Set File Role
 */
export const documentsSetFileRole = <ThrowOnError extends boolean = false>(options: Options<DocumentsSetFileRoleData, ThrowOnError>): RequestResult<DocumentsSetFileRoleResponses, DocumentsSetFileRoleErrors, ThrowOnError> => (options.client ?? client).patch<DocumentsSetFileRoleResponses, DocumentsSetFileRoleErrors, ThrowOnError>({
    url: '/api/documents/documents/{document_id}/revisions/{revision_id}/files/{file_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete File
 *
 * Always refused in this change: completed files are never hard-deleted
 * (``document.referenced``).
 */
export const documentsDeleteFile = <ThrowOnError extends boolean = false>(options: Options<DocumentsDeleteFileData, ThrowOnError>): RequestResult<unknown, DocumentsDeleteFileErrors, ThrowOnError> => (options.client ?? client).delete<unknown, DocumentsDeleteFileErrors, ThrowOnError>({ url: '/api/documents/files/{file_id}', ...options });

/**
 * Replace File Bytes
 *
 * Always refused: completed bytes are immutable (``document.file_immutable``).
 */
export const documentsReplaceFileBytes = <ThrowOnError extends boolean = false>(options: Options<DocumentsReplaceFileBytesData, ThrowOnError>): RequestResult<unknown, DocumentsReplaceFileBytesErrors, ThrowOnError> => (options.client ?? client).put<unknown, DocumentsReplaceFileBytesErrors, ThrowOnError>({ url: '/api/documents/files/{file_id}/content', ...options });

/**
 * File Presentation
 */
export const documentsFilePresentation = <ThrowOnError extends boolean = false>(options: Options<DocumentsFilePresentationData, ThrowOnError>): RequestResult<DocumentsFilePresentationResponses, DocumentsFilePresentationErrors, ThrowOnError> => (options.client ?? client).get<DocumentsFilePresentationResponses, DocumentsFilePresentationErrors, ThrowOnError>({ url: '/api/documents/files/{file_id}/presentation', ...options });

/**
 * Resolve Presentation
 */
export const documentsResolvePresentation = <ThrowOnError extends boolean = false>(options: Options<DocumentsResolvePresentationData, ThrowOnError>): RequestResult<DocumentsResolvePresentationResponses, DocumentsResolvePresentationErrors, ThrowOnError> => (options.client ?? client).post<DocumentsResolvePresentationResponses, DocumentsResolvePresentationErrors, ThrowOnError>({
    url: '/api/documents/presentations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Search Documents
 *
 * Filename, document number, title or exact SHA-256 within the active organization.
 */
export const documentsSearchDocuments = <ThrowOnError extends boolean = false>(options?: Options<DocumentsSearchDocumentsData, ThrowOnError>): RequestResult<DocumentsSearchDocumentsResponses, DocumentsSearchDocumentsErrors, ThrowOnError> => (options?.client ?? client).get<DocumentsSearchDocumentsResponses, DocumentsSearchDocumentsErrors, ThrowOnError>({ url: '/api/documents/search', ...options });

/**
 * Create Upload
 */
export const documentsCreateUpload = <ThrowOnError extends boolean = false>(options: Options<DocumentsCreateUploadData, ThrowOnError>): RequestResult<DocumentsCreateUploadResponses, DocumentsCreateUploadErrors, ThrowOnError> => (options.client ?? client).post<DocumentsCreateUploadResponses, DocumentsCreateUploadErrors, ThrowOnError>({
    url: '/api/documents/uploads',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Upload
 */
export const documentsGetUpload = <ThrowOnError extends boolean = false>(options: Options<DocumentsGetUploadData, ThrowOnError>): RequestResult<DocumentsGetUploadResponses, DocumentsGetUploadErrors, ThrowOnError> => (options.client ?? client).get<DocumentsGetUploadResponses, DocumentsGetUploadErrors, ThrowOnError>({ url: '/api/documents/uploads/{upload_id}', ...options });

/**
 * Abort Upload
 */
export const documentsAbortUpload = <ThrowOnError extends boolean = false>(options: Options<DocumentsAbortUploadData, ThrowOnError>): RequestResult<DocumentsAbortUploadResponses, DocumentsAbortUploadErrors, ThrowOnError> => (options.client ?? client).post<DocumentsAbortUploadResponses, DocumentsAbortUploadErrors, ThrowOnError>({ url: '/api/documents/uploads/{upload_id}/abort', ...options });

/**
 * Complete Upload
 */
export const documentsCompleteUpload = <ThrowOnError extends boolean = false>(options: Options<DocumentsCompleteUploadData, ThrowOnError>): RequestResult<DocumentsCompleteUploadResponses, DocumentsCompleteUploadErrors, ThrowOnError> => (options.client ?? client).post<DocumentsCompleteUploadResponses, DocumentsCompleteUploadErrors, ThrowOnError>({
    url: '/api/documents/uploads/{upload_id}/complete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upload Part Urls
 */
export const documentsUploadPartUrls = <ThrowOnError extends boolean = false>(options: Options<DocumentsUploadPartUrlsData, ThrowOnError>): RequestResult<DocumentsUploadPartUrlsResponses, DocumentsUploadPartUrlsErrors, ThrowOnError> => (options.client ?? client).post<DocumentsUploadPartUrlsResponses, DocumentsUploadPartUrlsErrors, ThrowOnError>({
    url: '/api/documents/uploads/{upload_id}/part-urls',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Catalogue
 */
export const engineeringListCatalogue = <ThrowOnError extends boolean = false>(options?: Options<EngineeringListCatalogueData, ThrowOnError>): RequestResult<EngineeringListCatalogueResponses, EngineeringListCatalogueErrors, ThrowOnError> => (options?.client ?? client).get<EngineeringListCatalogueResponses, EngineeringListCatalogueErrors, ThrowOnError>({ url: '/api/engineering/catalogue', ...options });

/**
 * Create Catalogue Item
 */
export const engineeringCreateCatalogueItem = <ThrowOnError extends boolean = false>(options: Options<EngineeringCreateCatalogueItemData, ThrowOnError>): RequestResult<EngineeringCreateCatalogueItemResponses, EngineeringCreateCatalogueItemErrors, ThrowOnError> => (options.client ?? client).post<EngineeringCreateCatalogueItemResponses, EngineeringCreateCatalogueItemErrors, ThrowOnError>({
    url: '/api/engineering/catalogue',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Change Catalogue Item
 */
export const engineeringChangeCatalogueItem = <ThrowOnError extends boolean = false>(options: Options<EngineeringChangeCatalogueItemData, ThrowOnError>): RequestResult<EngineeringChangeCatalogueItemResponses, EngineeringChangeCatalogueItemErrors, ThrowOnError> => (options.client ?? client).patch<EngineeringChangeCatalogueItemResponses, EngineeringChangeCatalogueItemErrors, ThrowOnError>({
    url: '/api/engineering/catalogue/{item_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Revision
 */
export const engineeringUpdateRevision = <ThrowOnError extends boolean = false>(options: Options<EngineeringUpdateRevisionData, ThrowOnError>): RequestResult<EngineeringUpdateRevisionResponses, EngineeringUpdateRevisionErrors, ThrowOnError> => (options.client ?? client).patch<EngineeringUpdateRevisionResponses, EngineeringUpdateRevisionErrors, ThrowOnError>({
    url: '/api/engineering/part-revisions/{revision_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Decide Attribute Proposal
 */
export const engineeringDecideAttributeProposal = <ThrowOnError extends boolean = false>(options: Options<EngineeringDecideAttributeProposalData, ThrowOnError>): RequestResult<EngineeringDecideAttributeProposalResponses, EngineeringDecideAttributeProposalErrors, ThrowOnError> => (options.client ?? client).post<EngineeringDecideAttributeProposalResponses, EngineeringDecideAttributeProposalErrors, ThrowOnError>({
    url: '/api/engineering/part-revisions/{revision_id}/attribute-proposals/{proposal_id}/decision',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirm Attribute
 */
export const engineeringConfirmAttribute = <ThrowOnError extends boolean = false>(options: Options<EngineeringConfirmAttributeData, ThrowOnError>): RequestResult<EngineeringConfirmAttributeResponses, EngineeringConfirmAttributeErrors, ThrowOnError> => (options.client ?? client).post<EngineeringConfirmAttributeResponses, EngineeringConfirmAttributeErrors, ThrowOnError>({
    url: '/api/engineering/part-revisions/{revision_id}/attributes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Link Evidence
 */
export const engineeringLinkEvidence = <ThrowOnError extends boolean = false>(options: Options<EngineeringLinkEvidenceData, ThrowOnError>): RequestResult<EngineeringLinkEvidenceResponses, EngineeringLinkEvidenceErrors, ThrowOnError> => (options.client ?? client).post<EngineeringLinkEvidenceResponses, EngineeringLinkEvidenceErrors, ThrowOnError>({
    url: '/api/engineering/part-revisions/{revision_id}/evidence',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unlink Evidence
 *
 * Unlinking is recorded (append-only history); documents are never touched.
 */
export const engineeringUnlinkEvidence = <ThrowOnError extends boolean = false>(options: Options<EngineeringUnlinkEvidenceData, ThrowOnError>): RequestResult<EngineeringUnlinkEvidenceResponses, EngineeringUnlinkEvidenceErrors, ThrowOnError> => (options.client ?? client).delete<EngineeringUnlinkEvidenceResponses, EngineeringUnlinkEvidenceErrors, ThrowOnError>({ url: '/api/engineering/part-revisions/{revision_id}/evidence/{link_id}', ...options });

/**
 * Ensure Recipe
 *
 * The revision's estimate recipe (created on first use; idempotent).
 */
export const engineeringEnsureRecipe = <ThrowOnError extends boolean = false>(options: Options<EngineeringEnsureRecipeData, ThrowOnError>): RequestResult<EngineeringEnsureRecipeResponses, EngineeringEnsureRecipeErrors, ThrowOnError> => (options.client ?? client).post<EngineeringEnsureRecipeResponses, EngineeringEnsureRecipeErrors, ThrowOnError>({ url: '/api/engineering/part-revisions/{revision_id}/recipe', ...options });

/**
 * Part Revision Reference
 */
export const engineeringPartRevisionReference = <ThrowOnError extends boolean = false>(options: Options<EngineeringPartRevisionReferenceData, ThrowOnError>): RequestResult<EngineeringPartRevisionReferenceResponses, EngineeringPartRevisionReferenceErrors, ThrowOnError> => (options.client ?? client).get<EngineeringPartRevisionReferenceResponses, EngineeringPartRevisionReferenceErrors, ThrowOnError>({ url: '/api/engineering/part-revisions/{revision_id}/reference', ...options });

/**
 * Search Parts
 *
 * Part number, placeholder, name, revision label or linked drawing number/filename.
 */
export const engineeringSearchParts = <ThrowOnError extends boolean = false>(options?: Options<EngineeringSearchPartsData, ThrowOnError>): RequestResult<EngineeringSearchPartsResponses, EngineeringSearchPartsErrors, ThrowOnError> => (options?.client ?? client).get<EngineeringSearchPartsResponses, EngineeringSearchPartsErrors, ThrowOnError>({ url: '/api/engineering/parts', ...options });

/**
 * Create Part
 */
export const engineeringCreatePart = <ThrowOnError extends boolean = false>(options: Options<EngineeringCreatePartData, ThrowOnError>): RequestResult<EngineeringCreatePartResponses, EngineeringCreatePartErrors, ThrowOnError> => (options.client ?? client).post<EngineeringCreatePartResponses, EngineeringCreatePartErrors, ThrowOnError>({
    url: '/api/engineering/parts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Part
 */
export const engineeringGetPart = <ThrowOnError extends boolean = false>(options: Options<EngineeringGetPartData, ThrowOnError>): RequestResult<EngineeringGetPartResponses, EngineeringGetPartErrors, ThrowOnError> => (options.client ?? client).get<EngineeringGetPartResponses, EngineeringGetPartErrors, ThrowOnError>({ url: '/api/engineering/parts/{part_id}', ...options });

/**
 * Update Part
 */
export const engineeringUpdatePart = <ThrowOnError extends boolean = false>(options: Options<EngineeringUpdatePartData, ThrowOnError>): RequestResult<EngineeringUpdatePartResponses, EngineeringUpdatePartErrors, ThrowOnError> => (options.client ?? client).patch<EngineeringUpdatePartResponses, EngineeringUpdatePartErrors, ThrowOnError>({
    url: '/api/engineering/parts/{part_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record Equivalence
 */
export const engineeringRecordEquivalence = <ThrowOnError extends boolean = false>(options: Options<EngineeringRecordEquivalenceData, ThrowOnError>): RequestResult<EngineeringRecordEquivalenceResponses, EngineeringRecordEquivalenceErrors, ThrowOnError> => (options.client ?? client).post<EngineeringRecordEquivalenceResponses, EngineeringRecordEquivalenceErrors, ThrowOnError>({
    url: '/api/engineering/parts/{part_id}/equivalences',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Replace Part
 */
export const engineeringReplacePart = <ThrowOnError extends boolean = false>(options: Options<EngineeringReplacePartData, ThrowOnError>): RequestResult<EngineeringReplacePartResponses, EngineeringReplacePartErrors, ThrowOnError> => (options.client ?? client).post<EngineeringReplacePartResponses, EngineeringReplacePartErrors, ThrowOnError>({
    url: '/api/engineering/parts/{part_id}/replacement',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Revision
 */
export const engineeringCreateRevision = <ThrowOnError extends boolean = false>(options: Options<EngineeringCreateRevisionData, ThrowOnError>): RequestResult<EngineeringCreateRevisionResponses, EngineeringCreateRevisionErrors, ThrowOnError> => (options.client ?? client).post<EngineeringCreateRevisionResponses, EngineeringCreateRevisionErrors, ThrowOnError>({
    url: '/api/engineering/parts/{part_id}/revisions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record Signal
 */
export const engineeringRecordSignal = <ThrowOnError extends boolean = false>(options: Options<EngineeringRecordSignalData, ThrowOnError>): RequestResult<EngineeringRecordSignalResponses, EngineeringRecordSignalErrors, ThrowOnError> => (options.client ?? client).post<EngineeringRecordSignalResponses, EngineeringRecordSignalErrors, ThrowOnError>({
    url: '/api/engineering/parts/{part_id}/signals',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Decide Signal
 */
export const engineeringDecideSignal = <ThrowOnError extends boolean = false>(options: Options<EngineeringDecideSignalData, ThrowOnError>): RequestResult<EngineeringDecideSignalResponses, EngineeringDecideSignalErrors, ThrowOnError> => (options.client ?? client).post<EngineeringDecideSignalResponses, EngineeringDecideSignalErrors, ThrowOnError>({
    url: '/api/engineering/parts/{part_id}/signals/{signal_id}/decision',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Recipe Version
 */
export const engineeringGetRecipeVersion = <ThrowOnError extends boolean = false>(options: Options<EngineeringGetRecipeVersionData, ThrowOnError>): RequestResult<EngineeringGetRecipeVersionResponses, EngineeringGetRecipeVersionErrors, ThrowOnError> => (options.client ?? client).get<EngineeringGetRecipeVersionResponses, EngineeringGetRecipeVersionErrors, ThrowOnError>({ url: '/api/engineering/recipe-versions/{version_id}', ...options });

/**
 * Get Recipe
 */
export const engineeringGetRecipe = <ThrowOnError extends boolean = false>(options: Options<EngineeringGetRecipeData, ThrowOnError>): RequestResult<EngineeringGetRecipeResponses, EngineeringGetRecipeErrors, ThrowOnError> => (options.client ?? client).get<EngineeringGetRecipeResponses, EngineeringGetRecipeErrors, ThrowOnError>({ url: '/api/engineering/recipes/{recipe_id}', ...options });

/**
 * Save Recipe Version
 */
export const engineeringSaveRecipeVersion = <ThrowOnError extends boolean = false>(options: Options<EngineeringSaveRecipeVersionData, ThrowOnError>): RequestResult<EngineeringSaveRecipeVersionResponses, EngineeringSaveRecipeVersionErrors, ThrowOnError> => (options.client ?? client).post<EngineeringSaveRecipeVersionResponses, EngineeringSaveRecipeVersionErrors, ThrowOnError>({
    url: '/api/engineering/recipes/{recipe_id}/versions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Technical Basis
 *
 * A draft read with current revision tokens; it never releases or locks anything.
 */
export const engineeringTechnicalBasis = <ThrowOnError extends boolean = false>(options: Options<EngineeringTechnicalBasisData, ThrowOnError>): RequestResult<EngineeringTechnicalBasisResponses, EngineeringTechnicalBasisErrors, ThrowOnError> => (options.client ?? client).get<EngineeringTechnicalBasisResponses, EngineeringTechnicalBasisErrors, ThrowOnError>({ url: '/api/engineering/technical-basis', ...options });

/**
 * Live
 */
export const healthLive = <ThrowOnError extends boolean = false>(options?: Options<HealthLiveData, ThrowOnError>): RequestResult<HealthLiveResponses, unknown, ThrowOnError> => (options?.client ?? client).get<HealthLiveResponses, unknown, ThrowOnError>({ url: '/api/health/live', ...options });

/**
 * Ready
 */
export const healthReady = <ThrowOnError extends boolean = false>(options?: Options<HealthReadyData, ThrowOnError>): RequestResult<HealthReadyResponses, unknown, ThrowOnError> => (options?.client ?? client).get<HealthReadyResponses, unknown, ThrowOnError>({ url: '/api/health/ready', ...options });

/**
 * List Audit
 */
export const platformListAudit = <ThrowOnError extends boolean = false>(options?: Options<PlatformListAuditData, ThrowOnError>): RequestResult<PlatformListAuditResponses, PlatformListAuditErrors, ThrowOnError> => (options?.client ?? client).get<PlatformListAuditResponses, PlatformListAuditErrors, ThrowOnError>({ url: '/api/platform/audit', ...options });

/**
 * List Invitations
 */
export const platformListInvitations = <ThrowOnError extends boolean = false>(options?: Options<PlatformListInvitationsData, ThrowOnError>): RequestResult<PlatformListInvitationsResponses, PlatformListInvitationsErrors, ThrowOnError> => (options?.client ?? client).get<PlatformListInvitationsResponses, PlatformListInvitationsErrors, ThrowOnError>({ url: '/api/platform/invitations', ...options });

/**
 * Invite
 */
export const platformInvite = <ThrowOnError extends boolean = false>(options: Options<PlatformInviteData, ThrowOnError>): RequestResult<PlatformInviteResponses, PlatformInviteErrors, ThrowOnError> => (options.client ?? client).post<PlatformInviteResponses, PlatformInviteErrors, ThrowOnError>({
    url: '/api/platform/invitations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Change Invitation Role
 */
export const platformChangeInvitationRole = <ThrowOnError extends boolean = false>(options: Options<PlatformChangeInvitationRoleData, ThrowOnError>): RequestResult<PlatformChangeInvitationRoleResponses, PlatformChangeInvitationRoleErrors, ThrowOnError> => (options.client ?? client).patch<PlatformChangeInvitationRoleResponses, PlatformChangeInvitationRoleErrors, ThrowOnError>({
    url: '/api/platform/invitations/{invitation_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Renew
 */
export const platformRenew = <ThrowOnError extends boolean = false>(options: Options<PlatformRenewData, ThrowOnError>): RequestResult<PlatformRenewResponses, PlatformRenewErrors, ThrowOnError> => (options.client ?? client).post<PlatformRenewResponses, PlatformRenewErrors, ThrowOnError>({ url: '/api/platform/invitations/{invitation_id}/renew', ...options });

/**
 * Revoke
 */
export const platformRevoke = <ThrowOnError extends boolean = false>(options: Options<PlatformRevokeData, ThrowOnError>): RequestResult<PlatformRevokeResponses, PlatformRevokeErrors, ThrowOnError> => (options.client ?? client).post<PlatformRevokeResponses, PlatformRevokeErrors, ThrowOnError>({ url: '/api/platform/invitations/{invitation_id}/revoke', ...options });

/**
 * Get Me
 */
export const platformGetMe = <ThrowOnError extends boolean = false>(options?: Options<PlatformGetMeData, ThrowOnError>): RequestResult<PlatformGetMeResponses, PlatformGetMeErrors, ThrowOnError> => (options?.client ?? client).get<PlatformGetMeResponses, PlatformGetMeErrors, ThrowOnError>({ url: '/api/platform/me', ...options });

/**
 * Patch Me
 */
export const platformPatchMe = <ThrowOnError extends boolean = false>(options: Options<PlatformPatchMeData, ThrowOnError>): RequestResult<PlatformPatchMeResponses, PlatformPatchMeErrors, ThrowOnError> => (options.client ?? client).patch<PlatformPatchMeResponses, PlatformPatchMeErrors, ThrowOnError>({
    url: '/api/platform/me',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Members
 */
export const platformListMembers = <ThrowOnError extends boolean = false>(options?: Options<PlatformListMembersData, ThrowOnError>): RequestResult<PlatformListMembersResponses, PlatformListMembersErrors, ThrowOnError> => (options?.client ?? client).get<PlatformListMembersResponses, PlatformListMembersErrors, ThrowOnError>({ url: '/api/platform/members', ...options });

/**
 * Change Role
 */
export const platformChangeRole = <ThrowOnError extends boolean = false>(options: Options<PlatformChangeRoleData, ThrowOnError>): RequestResult<PlatformChangeRoleResponses, PlatformChangeRoleErrors, ThrowOnError> => (options.client ?? client).patch<PlatformChangeRoleResponses, PlatformChangeRoleErrors, ThrowOnError>({
    url: '/api/platform/members/{user_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Deactivate
 */
export const platformDeactivate = <ThrowOnError extends boolean = false>(options: Options<PlatformDeactivateData, ThrowOnError>): RequestResult<PlatformDeactivateResponses, PlatformDeactivateErrors, ThrowOnError> => (options.client ?? client).post<PlatformDeactivateResponses, PlatformDeactivateErrors, ThrowOnError>({ url: '/api/platform/members/{user_id}/deactivate', ...options });

/**
 * Reactivate
 */
export const platformReactivate = <ThrowOnError extends boolean = false>(options: Options<PlatformReactivateData, ThrowOnError>): RequestResult<PlatformReactivateResponses, PlatformReactivateErrors, ThrowOnError> => (options.client ?? client).post<PlatformReactivateResponses, PlatformReactivateErrors, ThrowOnError>({ url: '/api/platform/members/{user_id}/reactivate', ...options });

/**
 * List Organizations
 */
export const platformListOrganizations = <ThrowOnError extends boolean = false>(options?: Options<PlatformListOrganizationsData, ThrowOnError>): RequestResult<PlatformListOrganizationsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<PlatformListOrganizationsResponses, unknown, ThrowOnError>({ url: '/api/platform/organizations', ...options });

/**
 * Get Capability Mapping
 */
export const platformGetCapabilityMapping = <ThrowOnError extends boolean = false>(options: Options<PlatformGetCapabilityMappingData, ThrowOnError>): RequestResult<PlatformGetCapabilityMappingResponses, PlatformGetCapabilityMappingErrors, ThrowOnError> => (options.client ?? client).get<PlatformGetCapabilityMappingResponses, PlatformGetCapabilityMappingErrors, ThrowOnError>({ url: '/api/platform/organizations/{organization_id}/capability-mapping', ...options });

/**
 * Change Capability Mapping
 */
export const platformChangeCapabilityMapping = <ThrowOnError extends boolean = false>(options: Options<PlatformChangeCapabilityMappingData, ThrowOnError>): RequestResult<PlatformChangeCapabilityMappingResponses, PlatformChangeCapabilityMappingErrors, ThrowOnError> => (options.client ?? client).put<PlatformChangeCapabilityMappingResponses, PlatformChangeCapabilityMappingErrors, ThrowOnError>({
    url: '/api/platform/organizations/{organization_id}/capability-mapping',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Policies
 */
export const platformGetPolicies = <ThrowOnError extends boolean = false>(options: Options<PlatformGetPoliciesData, ThrowOnError>): RequestResult<PlatformGetPoliciesResponses, PlatformGetPoliciesErrors, ThrowOnError> => (options.client ?? client).get<PlatformGetPoliciesResponses, PlatformGetPoliciesErrors, ThrowOnError>({ url: '/api/platform/organizations/{organization_id}/policies', ...options });

/**
 * Activate Policies
 */
export const platformActivatePolicies = <ThrowOnError extends boolean = false>(options: Options<PlatformActivatePoliciesData, ThrowOnError>): RequestResult<PlatformActivatePoliciesResponses, PlatformActivatePoliciesErrors, ThrowOnError> => (options.client ?? client).post<PlatformActivatePoliciesResponses, PlatformActivatePoliciesErrors, ThrowOnError>({
    url: '/api/platform/organizations/{organization_id}/policies/activate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Save Policy Draft
 */
export const platformSavePolicyDraft = <ThrowOnError extends boolean = false>(options: Options<PlatformSavePolicyDraftData, ThrowOnError>): RequestResult<PlatformSavePolicyDraftResponses, PlatformSavePolicyDraftErrors, ThrowOnError> => (options.client ?? client).put<PlatformSavePolicyDraftResponses, PlatformSavePolicyDraftErrors, ThrowOnError>({
    url: '/api/platform/organizations/{organization_id}/policies/draft',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Policy Versions
 */
export const platformListPolicyVersions = <ThrowOnError extends boolean = false>(options: Options<PlatformListPolicyVersionsData, ThrowOnError>): RequestResult<PlatformListPolicyVersionsResponses, PlatformListPolicyVersionsErrors, ThrowOnError> => (options.client ?? client).get<PlatformListPolicyVersionsResponses, PlatformListPolicyVersionsErrors, ThrowOnError>({ url: '/api/platform/organizations/{organization_id}/policies/versions', ...options });

/**
 * Get Policy Version
 */
export const platformGetPolicyVersion = <ThrowOnError extends boolean = false>(options: Options<PlatformGetPolicyVersionData, ThrowOnError>): RequestResult<PlatformGetPolicyVersionResponses, PlatformGetPolicyVersionErrors, ThrowOnError> => (options.client ?? client).get<PlatformGetPolicyVersionResponses, PlatformGetPolicyVersionErrors, ThrowOnError>({ url: '/api/platform/organizations/{organization_id}/policies/versions/{version_id}', ...options });

/**
 * Save Calculation
 */
export const salesSaveCalculation = <ThrowOnError extends boolean = false>(options: Options<SalesSaveCalculationData, ThrowOnError>): RequestResult<SalesSaveCalculationResponses, SalesSaveCalculationErrors, ThrowOnError> => (options.client ?? client).post<SalesSaveCalculationResponses, SalesSaveCalculationErrors, ThrowOnError>({
    url: '/api/sales/calculations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Preview Calculation
 *
 * Transient: creates no calculation revision and no decision record.
 */
export const salesPreviewCalculation = <ThrowOnError extends boolean = false>(options: Options<SalesPreviewCalculationData, ThrowOnError>): RequestResult<SalesPreviewCalculationResponses, SalesPreviewCalculationErrors, ThrowOnError> => (options.client ?? client).post<SalesPreviewCalculationResponses, SalesPreviewCalculationErrors, ThrowOnError>({
    url: '/api/sales/calculations/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Calculation
 */
export const salesGetCalculation = <ThrowOnError extends boolean = false>(options: Options<SalesGetCalculationData, ThrowOnError>): RequestResult<SalesGetCalculationResponses, SalesGetCalculationErrors, ThrowOnError> => (options.client ?? client).get<SalesGetCalculationResponses, SalesGetCalculationErrors, ThrowOnError>({ url: '/api/sales/calculations/{calculation_id}', ...options });

/**
 * Search Customers
 */
export const salesSearchCustomers = <ThrowOnError extends boolean = false>(options?: Options<SalesSearchCustomersData, ThrowOnError>): RequestResult<SalesSearchCustomersResponses, SalesSearchCustomersErrors, ThrowOnError> => (options?.client ?? client).get<SalesSearchCustomersResponses, SalesSearchCustomersErrors, ThrowOnError>({ url: '/api/sales/customers', ...options });

/**
 * Create Customer
 */
export const salesCreateCustomer = <ThrowOnError extends boolean = false>(options: Options<SalesCreateCustomerData, ThrowOnError>): RequestResult<SalesCreateCustomerResponses, SalesCreateCustomerErrors, ThrowOnError> => (options.client ?? client).post<SalesCreateCustomerResponses, SalesCreateCustomerErrors, ThrowOnError>({
    url: '/api/sales/customers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Customer
 */
export const salesGetCustomer = <ThrowOnError extends boolean = false>(options: Options<SalesGetCustomerData, ThrowOnError>): RequestResult<SalesGetCustomerResponses, SalesGetCustomerErrors, ThrowOnError> => (options.client ?? client).get<SalesGetCustomerResponses, SalesGetCustomerErrors, ThrowOnError>({ url: '/api/sales/customers/{customer_id}', ...options });

/**
 * Add Contact
 */
export const salesAddContact = <ThrowOnError extends boolean = false>(options: Options<SalesAddContactData, ThrowOnError>): RequestResult<SalesAddContactResponses, SalesAddContactErrors, ThrowOnError> => (options.client ?? client).post<SalesAddContactResponses, SalesAddContactErrors, ThrowOnError>({
    url: '/api/sales/customers/{customer_id}/contacts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Calculations
 */
export const salesListCalculations = <ThrowOnError extends boolean = false>(options: Options<SalesListCalculationsData, ThrowOnError>): RequestResult<SalesListCalculationsResponses, SalesListCalculationsErrors, ThrowOnError> => (options.client ?? client).get<SalesListCalculationsResponses, SalesListCalculationsErrors, ThrowOnError>({ url: '/api/sales/part-revisions/{part_revision_id}/calculations', ...options });

/**
 * Get Price Book Version
 */
export const salesGetPriceBookVersion = <ThrowOnError extends boolean = false>(options: Options<SalesGetPriceBookVersionData, ThrowOnError>): RequestResult<SalesGetPriceBookVersionResponses, SalesGetPriceBookVersionErrors, ThrowOnError> => (options.client ?? client).get<SalesGetPriceBookVersionResponses, SalesGetPriceBookVersionErrors, ThrowOnError>({ url: '/api/sales/price-book-versions/{version_id}', ...options });

/**
 * List Price Books
 */
export const salesListPriceBooks = <ThrowOnError extends boolean = false>(options?: Options<SalesListPriceBooksData, ThrowOnError>): RequestResult<SalesListPriceBooksResponses, SalesListPriceBooksErrors, ThrowOnError> => (options?.client ?? client).get<SalesListPriceBooksResponses, SalesListPriceBooksErrors, ThrowOnError>({ url: '/api/sales/price-books', ...options });

/**
 * Create Price Book
 */
export const salesCreatePriceBook = <ThrowOnError extends boolean = false>(options: Options<SalesCreatePriceBookData, ThrowOnError>): RequestResult<SalesCreatePriceBookResponses, SalesCreatePriceBookErrors, ThrowOnError> => (options.client ?? client).post<SalesCreatePriceBookResponses, SalesCreatePriceBookErrors, ThrowOnError>({
    url: '/api/sales/price-books',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Price Book
 */
export const salesGetPriceBook = <ThrowOnError extends boolean = false>(options: Options<SalesGetPriceBookData, ThrowOnError>): RequestResult<SalesGetPriceBookResponses, SalesGetPriceBookErrors, ThrowOnError> => (options.client ?? client).get<SalesGetPriceBookResponses, SalesGetPriceBookErrors, ThrowOnError>({ url: '/api/sales/price-books/{price_book_id}', ...options });

/**
 * Activate Price Book Version
 */
export const salesActivatePriceBookVersion = <ThrowOnError extends boolean = false>(options: Options<SalesActivatePriceBookVersionData, ThrowOnError>): RequestResult<SalesActivatePriceBookVersionResponses, SalesActivatePriceBookVersionErrors, ThrowOnError> => (options.client ?? client).post<SalesActivatePriceBookVersionResponses, SalesActivatePriceBookVersionErrors, ThrowOnError>({
    url: '/api/sales/price-books/{price_book_id}/activate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Price Book Version
 */
export const salesCreatePriceBookVersion = <ThrowOnError extends boolean = false>(options: Options<SalesCreatePriceBookVersionData, ThrowOnError>): RequestResult<SalesCreatePriceBookVersionResponses, SalesCreatePriceBookVersionErrors, ThrowOnError> => (options.client ?? client).post<SalesCreatePriceBookVersionResponses, SalesCreatePriceBookVersionErrors, ThrowOnError>({
    url: '/api/sales/price-books/{price_book_id}/versions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Quote Version
 */
export const salesGetQuoteVersion = <ThrowOnError extends boolean = false>(options: Options<SalesGetQuoteVersionData, ThrowOnError>): RequestResult<SalesGetQuoteVersionResponses, SalesGetQuoteVersionErrors, ThrowOnError> => (options.client ?? client).get<SalesGetQuoteVersionResponses, SalesGetQuoteVersionErrors, ThrowOnError>({ url: '/api/sales/quote-versions/{version_id}', ...options });

/**
 * Internal Summary
 *
 * The exact version with internal cost data for the not-an-offer print (read only).
 */
export const salesInternalSummary = <ThrowOnError extends boolean = false>(options: Options<SalesInternalSummaryData, ThrowOnError>): RequestResult<SalesInternalSummaryResponses, SalesInternalSummaryErrors, ThrowOnError> => (options.client ?? client).get<SalesInternalSummaryResponses, SalesInternalSummaryErrors, ThrowOnError>({ url: '/api/sales/quote-versions/{version_id}/internal-summary', ...options });

/**
 * Search Quotes
 *
 * Title, request number or customer name.
 */
export const salesSearchQuotes = <ThrowOnError extends boolean = false>(options?: Options<SalesSearchQuotesData, ThrowOnError>): RequestResult<SalesSearchQuotesResponses, SalesSearchQuotesErrors, ThrowOnError> => (options?.client ?? client).get<SalesSearchQuotesResponses, SalesSearchQuotesErrors, ThrowOnError>({ url: '/api/sales/quotes', ...options });

/**
 * Create Quote
 */
export const salesCreateQuote = <ThrowOnError extends boolean = false>(options: Options<SalesCreateQuoteData, ThrowOnError>): RequestResult<SalesCreateQuoteResponses, SalesCreateQuoteErrors, ThrowOnError> => (options.client ?? client).post<SalesCreateQuoteResponses, SalesCreateQuoteErrors, ThrowOnError>({
    url: '/api/sales/quotes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Quote
 */
export const salesGetQuote = <ThrowOnError extends boolean = false>(options: Options<SalesGetQuoteData, ThrowOnError>): RequestResult<SalesGetQuoteResponses, SalesGetQuoteErrors, ThrowOnError> => (options.client ?? client).get<SalesGetQuoteResponses, SalesGetQuoteErrors, ThrowOnError>({ url: '/api/sales/quotes/{quote_id}', ...options });

/**
 * Save Quote Version
 */
export const salesSaveQuoteVersion = <ThrowOnError extends boolean = false>(options: Options<SalesSaveQuoteVersionData, ThrowOnError>): RequestResult<SalesSaveQuoteVersionResponses, SalesSaveQuoteVersionErrors, ThrowOnError> => (options.client ?? client).post<SalesSaveQuoteVersionResponses, SalesSaveQuoteVersionErrors, ThrowOnError>({
    url: '/api/sales/quotes/{quote_id}/versions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Search Requests
 *
 * Request number, customer name, line description or linked drawing filename.
 */
export const salesSearchRequests = <ThrowOnError extends boolean = false>(options?: Options<SalesSearchRequestsData, ThrowOnError>): RequestResult<SalesSearchRequestsResponses, SalesSearchRequestsErrors, ThrowOnError> => (options?.client ?? client).get<SalesSearchRequestsResponses, SalesSearchRequestsErrors, ThrowOnError>({ url: '/api/sales/requests', ...options });

/**
 * Create Request
 */
export const salesCreateRequest = <ThrowOnError extends boolean = false>(options: Options<SalesCreateRequestData, ThrowOnError>): RequestResult<SalesCreateRequestResponses, SalesCreateRequestErrors, ThrowOnError> => (options.client ?? client).post<SalesCreateRequestResponses, SalesCreateRequestErrors, ThrowOnError>({
    url: '/api/sales/requests',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Request
 */
export const salesGetRequest = <ThrowOnError extends boolean = false>(options: Options<SalesGetRequestData, ThrowOnError>): RequestResult<SalesGetRequestResponses, SalesGetRequestErrors, ThrowOnError> => (options.client ?? client).get<SalesGetRequestResponses, SalesGetRequestErrors, ThrowOnError>({ url: '/api/sales/requests/{request_id}', ...options });

/**
 * List Supplier Evidence
 */
export const salesListSupplierEvidence = <ThrowOnError extends boolean = false>(options?: Options<SalesListSupplierEvidenceData, ThrowOnError>): RequestResult<SalesListSupplierEvidenceResponses, SalesListSupplierEvidenceErrors, ThrowOnError> => (options?.client ?? client).get<SalesListSupplierEvidenceResponses, SalesListSupplierEvidenceErrors, ThrowOnError>({ url: '/api/sales/supplier-evidence', ...options });

/**
 * Record Supplier Evidence
 */
export const salesRecordSupplierEvidence = <ThrowOnError extends boolean = false>(options: Options<SalesRecordSupplierEvidenceData, ThrowOnError>): RequestResult<SalesRecordSupplierEvidenceResponses, SalesRecordSupplierEvidenceErrors, ThrowOnError> => (options.client ?? client).post<SalesRecordSupplierEvidenceResponses, SalesRecordSupplierEvidenceErrors, ThrowOnError>({
    url: '/api/sales/supplier-evidence',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
